module.exports = __webpack_public_path__ + "static/media/oubre.1e9afa6d.jpg";